import { CNavItem, CNavLink } from '@coreui/react-pro'
import React from 'react'
import { useHistory } from 'react-router-dom'
import { reduxServices } from '../../reducers/reduxServices'
import { useAppDispatch } from '../../stateStore'
import useMobilePort from '../../middleware/hooks/useMobilePort'

type NavItemLinkProps = {
  url: string
  name: string
  disableNavItem?: boolean
}

export default function AppSidebarNavItemLink({
  url,
  name,
  disableNavItem = false,
}: NavItemLinkProps): JSX.Element {
  const dispatch = useAppDispatch()
  const history = useHistory()
  const isMobile = useMobilePort()

  const closeNavLink = () => {
    const navGroups = document.querySelectorAll('.nav-group')
    navGroups.forEach((e) => {
      e?.classList.remove('show')
    })
    if (isMobile) {
      dispatch(reduxServices.app.actions.toggleSidebar())
    }
  }

  function childLink(name: string) {
    return (
      <>
        <span className="child-arrow"></span>
        {name}
      </>
    )
  }

  return (
    <CNavItem>
      <CNavLink
        className="mobile-child-link"
        onClick={() => {
          if (!disableNavItem) history.push(`/${url}`)
          closeNavLink()
        }}
        disabled={disableNavItem}
      >
        {childLink(name)}
      </CNavLink>
    </CNavItem>
  )
}
